import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State, TemplateStaff } from './types';

export const getInitialState = (): State => ({
  templateStaff: [] as TemplateStaff[],
  isTemplateStaffLoading: false,
  totalTemplateStaffCount: 0
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
